<template>
    <div :data-theme="currentTheme">
        <div class="map_content" :class="{ open: isShowLocationDetail }">
            <div class="map_loader">
                <div class="sk-cube-grid">
                    <button class="btn btn-square loading"></button>
                </div>
            </div>
            <div
                class="absolute top-0 left-1 text-ellipsis overflow-hidden z-20 my-1 ml-1 sm:left-24 border-base-content/5 backdrop-blur-sm text-left card card-compact border border-2 m-2 shadow"
            >
                <div v-if="mapData.header_type !== 0" class="card p-2">
                    <a :href="displayLink">
                        <div class="flex items-center">
                            <div
                                class="avatar"
                                v-if="mapData.header_type === 2 || mapData.header_type === 3"
                            >
                                <div class="w-10 h-10 rounded">
                                    <img :src="mapData.logo_url" />
                                </div>
                            </div>
                            <div
                                class="flex flex-col items-start text-sm mx-2"
                                v-if="mapData.header_type === 1 || mapData.header_type === 3"
                            >
                                <div class="text-base-content font-bold">
                                    {{ mapData.title }}
                                </div>
                                <div class="text-base-content/80 font-bold text-xs">
                                    {{ mapData.sub_title }}
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="map_iframe">
                <div id="map" style="height: 100%" class="mw-75 mh-75"></div>
            </div>
            <side-bar-navi
                @toggledSubSidebar="openSubSidebar"
                :open="open"
                :trans="trans"
                :show-introduction-btn="
                    introductionData && Object.keys(this.introductionData).length > 0
                "
                :show-route-btn="showRouteBtn"
                :indicator-state="sideBarNaviIndicatorState"
                :show-gallery-btn="mapData.show_gallery"
                :show-directions-btn="useMapboxDirections"
                :show-list-search-btn="show.searchBtn"
                :go-to-main-map="goToMainMap"
                :banner-url="mapData.banner_url"
                :banner-link="mapData.banner_link"
            >
            </side-bar-navi>
            <sub-side-bar
                :default-state="isShowLocationDetail ? 'open' : subSideBarState"
                :is-show-location-detail="isShowLocationDetail"
                @closedLocationDetail="closedLocationDetail"
                @changedState="changeState"
            >
                <location-list-box
                    v-show="open.locationListBox"
                    :location-list="locationList"
                    :my-smart-map="mySmartMap"
                    :parcel-resource="parcelResource"
                    @closed="closeSubSidebar('locationListBox')"
                    @changedLocationDetail="changeLocationDetail"
                ></location-list-box>
                <list-search-box
                    ref="listSearchBoxComponent"
                    v-show="open.listSearchBox"
                    @closed="open.listSearchBox = false"
                    :location-resource="locationResource"
                    :item-resource="itemResource"
                    :facility-resource="facilityResource"
                    :area-resource="areaResource"
                    :searchable-area-ids="searchableAreaIds"
                    :category-data="categoryData"
                    :number-of-result="locationList.length"
                    @filtered="filterLocations"
                    @showedLocationsList="open.locationListBox = true"
                    @toggledSubSidebar="openSubSidebar"
                    @isClickedLocationsFound="(payload) => (isClickedLocationsFound = payload)"
                    :current-tag="currentTag"
                    :location-list="locationList"
                    :parcel-resource="parcelResource"
                    @changedLocationDetail="changeLocationDetail"
                    @isOpenedListSearchBox="(payload) => (isOpenedListSearchBox = payload)"
                    :current-state="currentState"
                ></list-search-box>
                <locale-box
                    v-show="open.localeBox"
                    :locales="mapData.locales"
                    @closed="open.localeBox = false"
                ></locale-box>
                <introduction
                    v-show="open.introductionBox"
                    @closed="closeIntroduction"
                    :introduction-data="introductionData"
                    :trans="trans"
                ></introduction>
                <gallery
                    v-show="open.galleryBox"
                    @closed="open.galleryBox = false"
                    :trans="trans"
                ></gallery>
                <directions-control
                    v-show="open.directionsBox"
                    @closed="open.directionsBox = false"
                    :trans="trans"
                    :location-resource="locationResource"
                    :directions-control="directionsControl"
                    :click-on-map-to-choose="isClickedForDirections"
                    :chosen-place="chosenLocationForDirections"
                    :alert-allow-to-access-location="trans.alert.allow_to_access_your_location"
                    :default-orig-and-dest="defaultOrigAndDest"
                    @clearChosen="clearedChosen"
                    @closeDirectionsControl="open.directionsControl = false"
                ></directions-control>
                <location-detail
                    :location="currentLocation.properties"
                    :location-list="locationGeoJson"
                    :coordinates="currentLocation.geometry.coordinates"
                    :area-resource="areaResource"
                    :defaultLocale="mapData.current_locale"
                    :useAudioGuide="mapData.client.use_audio_guide"
                    :useCongestion="mapData.client.use_congestion"
                    :use-mapbox-directions="useMapboxDirections"
                    :use-google-map-directions="useGoogleMapDirections"
                    :useQRCode="mapData.client.use_qr_code"
                    :hashId="mapData.hash_id"
                    :hideNearSpots="mapData.hide_near_spots"
                    @closed="closedLocationDetail"
                    @changedLocationDetail="changeLocationDetail"
                    @goToNextPoint="goToNextPoint"
                    v-if="currentLocation"
                    @clickTag="updateCurrentTag"
                    @toggledSubSidebar="openSubSidebar"
                    :is-opened-list-search-box="isOpenedListSearchBox"
                    :current-state="currentState"
                    :has-list-search-box="show.searchBtn"
                    @selectedCategory="selectCategory"
                ></location-detail>
                <map-setting
                    v-if="mySmartMap && open.mapSetting"
                    :map-data="mapData"
                    :my-smart-map="mySmartMap"
                    :show="show"
                    :lang="currentLang"
                    :switch-language="switchLanguage"
                    @closed="open.mapSetting = false"
                    @changedTheme="(payload) => (currentTheme = payload)"
                ></map-setting>
                <routes
                    v-show="mySmartMap && open.routeBox"
                    @closed="open.routeBox = false"
                    :show-list-route="open.routeBox"
                    :my-smart-map="mySmartMap"
                    :filterLocationsByRoute="filterLocationsByRoute"
                    @showRouteBtn="(payload) => (showRouteBtn = payload)"
                    :trans="trans"
                    @toggledSubSidebar="openSubSidebar"
                    :route-locations="routeLocations"
                    @chooseLocation="(payload) => onClickMarker(payload)"
                ></routes>
            </sub-side-bar>
            <bottom-sheet-category
                :current-sheet="open.categoryBox ? 'categorysheet' : ''"
                :map-id="mapData.id"
                :locale="
                    mapData.current_locale != mapData.default_locale ? mapData.current_locale : ''
                "
                :categories="categoryData"
                :is-filtered="isFiltered"
                :resetFilter="resetFilter"
                @changedCategoryId="updateCurrentCategoryId"
                @closed="closeSubSidebar('categoryBox')"
                v-if="mySmartMap && open.categoryBox"
                :trans="trans"
                :currentCategoryId="currentCategoryId"
            ></bottom-sheet-category>
            <side-menu
                :show-zoom-btn="show.zoomBtn"
                :show-fullscreen="mapData.show_fullscreen"
                :show-switch-language="mapData.is_multi_localization"
                :show-refresh-btn="show.refreshBtn"
                :on-click-zoom="onClickZoom"
                :go-to-main-map="goToMainMap"
                @toggled="toggleMenu"
                :show-new-tab="mapData.show_new_tab"
                :display-link="displayLink"
                :trans="trans"
                :map-data="mapData"
            ></side-menu>
            <div class="absolute bottom-16 right-0 flex grid grid-cols-1 gap-2 m-2">
                <div class="join join-vertical shadow-sm w-10 z-10">
                    <button
                        class="btn join-item border border-base-content/5"
                        @click="onClickZoom(1)"
                    >
                        <a>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                stroke-width="2"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                ></path>
                            </svg>
                        </a>
                    </button>
                    <button
                        class="btn join-item shadow-sm border border-base-content/5"
                        @click="onClickZoom(-1)"
                    >
                        <a>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                stroke-width="2"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M18 12H6"
                                ></path>
                            </svg>
                        </a>
                    </button>
                </div>
                <button
                    class="btn btn-sm -shadow-sm border border-base-content/5 w-10 h-10 btn-compass"
                    v-show="show.geolocateBtn"
                ></button>
                <button
                    class="btn btn-sm shadow-sm border border-base-content/5 w-10 h-10"
                    v-show="show.geolocateBtn"
                    @click="triggerGeolocate"
                >
                    <span
                        class="material-symbols-outlined notranslate fill-current"
                        v-if="!isGeolocateLoading"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24"
                            viewBox="0 -960 960 960"
                            width="24"
                        >
                            <path
                                d="M516-120 402-402 120-516v-56l720-268-268 720h-56Zm26-148 162-436-436 162 196 78 78 196Zm-78-196Z"
                            />
                        </svg>
                    </span>
                    <span class="loading loading-spinner" v-else></span>
                </button>
            </div>
            <div
                class="tootip bg-base-100 white_box"
                :id="tooltip.id ? 'tooltip-' + tooltip.id : ''"
                v-show="tooltip.title && !isShowLocationDetail"
                :style="{ top: tooltip.top, left: tooltip.left }"
            >
                <p class="ttl">{{ tooltip.title }}</p>
            </div>
            <div v-if="mySmartMap">
                <area-marker
                    :my-smart-map="mySmartMap"
                    v-for="area in areaResource"
                    v-show="isShowAreaMaker(area)"
                    :area="area"
                    :key="'area-' + area.id"
                ></area-marker>
                <parcel-marker
                    :my-smart-map="mySmartMap"
                    v-for="parcel in parcelResource"
                    v-show="isShowParcelMaker(parcel)"
                    :parcel="parcel"
                    :key="'parcel-' + parcel.id"
                ></parcel-marker>
            </div>
            <div style="display: none">
                <div
                    class="bubble pin bg-primary h-12 w-12 rounded-full p-1"
                    ref="locationMarkerTemplate"
                >
                    <a href="javascript:void(0)" class="bubble_link"
                        ><img loading="lazy" class="inline rounded-full"
                    /></a>
                    <div class="stamp_group"></div>
                    <div id="currentCongestionTooltip"></div>
                </div>
                <div
                    class="bubble bg-secondary h-12 w-12 rounded-full p-1"
                    ref="clusterMarkerTemplate"
                >
                    <a href="javascript:void(0)" class="bubble_link"
                        ><img loading="lazy" class="inline rounded-full"
                    /></a>
                    <div class="count_box"></div>
                </div>
            </div>
            <div id="currentCongestion" style="display: none">
                <div v-for="(n, i) in 6" :key="i" :id="'congestion-level-' + i">
                    <congestion-icon-level :level="i" :type="1" :key="i"></congestion-icon-level>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import axios from 'axios';
import MapBox from '../mixins/MapBox/Map';
import LocationDetail from './LocationDetail';
import Category from './Category';
import BottomSheetCategory from './BottomSheetCategory';
import LanguageBox from './LanguageBox';
import LocationMarker from './LocationMarker';
import Supercluster from 'supercluster';
import Cluster from './Cluster';
import AreaMarker from './AreaMarker';
import ParcelMarker from './ParcelMarker';
import Fullscreen from './Fullscreen';
import SearchBox from './SearchBox';
import SideMenu from './SideMenu';
import LocationListBox from './LocationListBox';
import DirectionsControl from './DirectionsControl';
import MapSetting from './MapSetting';
import CongestionIconLevel from './CongestionIconLevel';
import SideBarNavi from './SideBarNavi';
import { default as MarkerHelper } from '../mixins/Markers';
import { default as URLSearchParamsHelper } from '../mixins/URLSearchParams';
import * as turf from '@turf/turf';
import SubSideBar from './SubSideBar';
import LocaleBox from './LocaleBox';
import BottomSheet from './BottomSheet';
import Introduction from './Introduction';
import Routes from './Routes';
import Gallery from './Gallery';
import { default as SubSideBarHelper } from '../mixins/SubSideBar';
import { default as IntroductionHelper } from '../mixins/Introduction';
import { default as CurrentTagHelper } from '../mixins/CurrentTag';
import { default as APILocationResource } from '../api/LocationResource';
// import { default as APICategoryResource } from '../api/CategoryResource';
// import { default as APIBannerResource } from '../api/BannerResource';
// import { default as APIAudioGuideResource } from '../api/AudioGuideResource';
import { default as FilterHelper } from '../mixins/Filter';
import ListSearchBox from './ListSearchBox';
import { default as DefaultLanguageHelper } from '../mixins/DefaultLanguage';

export default {
    provide() {
        return {
            displayLink: this.displayLink,
            trans: this.trans,
            locale: this.mapData.current_locale,
            mapId: this.mapData.id,
            currentMapLink: this.currentMapLink
        };
    },
    mixins: [
        MapBox,
        MarkerHelper,
        URLSearchParamsHelper,
        SubSideBarHelper,
        IntroductionHelper,
        CurrentTagHelper,
        FilterHelper,
        APILocationResource,
        DefaultLanguageHelper
    ],
    components: {
        LocationDetail,
        Category,
        BottomSheetCategory,
        LanguageBox,
        LocationMarker,
        Cluster,
        AreaMarker,
        ParcelMarker,
        Fullscreen,
        SearchBox,
        LocationListBox,
        SideMenu,
        MapSetting,
        CongestionIconLevel,
        DirectionsControl,
        SideBarNavi,
        SubSideBar,
        LocaleBox,
        BottomSheet,
        Introduction,
        Routes,
        Gallery,
        ListSearchBox
    },
    props: {
        categoryData: {
            type: Array,
            default: function () {
                return [];
            }
        },
        audioGuides: {
            type: Array,
            default: function () {
                return [];
            }
        },
        congestionResource: {
            type: Array,
            default: function () {
                return [];
            }
        },
        bannerResource: {
            type: Array,
            default: function () {
                return [];
            }
        },
        searchableAreaIds: {
            type: Array,
            default: function () {
                return [];
            }
        },
        areaResource: {
            type: Array,
            default: function () {
                return [];
            }
        },
        itemResource: {
            type: Array,
            default: function () {
                return [];
            }
        },
        facilityResource: {
            type: Array,
            default: function () {
                return [];
            }
        },
        parcelResource: {
            type: Array,
            default: function () {
                return [];
            }
        },
        geofenceResource: {
            type: Array,
            default: function () {
                return [];
            }
        },
        mapData: {
            type: Object,
            default: function () {
                return null;
            }
        },
        displayLink: {
            type: String,
            default: ''
        },
        trans: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            mapIsLoaded: false,
            isFullscreen: false,
            locationGeoJson: [],
            parcelLocations: [],
            clusterGeoJson: [],
            pointsInCluster: [],
            pointsNotInCluster: [],
            superclusterIndex: null,
            currentCategoryId: 0,
            currentLocation: null,
            isShowLocationDetail: false,
            tooltip: {
                title: '',
                category_title: '',
                top: '',
                left: ''
            },
            temporarilyStopCluster: false,
            isInAreaZoomRange:
                this.areaResource.length > 0 &&
                this.mapData.zoom_level < this.mapData.location_zoom_range[0],
            iframeLink: '',
            mapStyles: {
                streets: 'mapbox://styles/mapbox/streets-v11',
                light: 'mapbox://styles/mapbox/light-v10',
                dark: 'mapbox://styles/mapbox/dark-v10',
                outdoors: 'mapbox://styles/mapbox/outdoors-v11',
                satellite: 'mapbox://styles/mapbox/satellite-streets-v11'
            },
            languageCodeText: {
                browser: 'ブラウザ言語',
                en: 'English',
                ja: '日本語',
                'zh-Hans': '中国語（簡体字）',
                'zh-Hant': '中国語（繁体字）',
                ko: '한국어',
                fr: 'Français',
                de: 'Deutsch',
                it: 'Italiano',
                pt: 'Português',
                ru: 'Русский язык',
                es: 'Español',
                ar: 'اللغة العربية'
            },
            currentLang: this.mapData.default_language,
            currentTheme: this.mapData.theme_color,
            show: {
                searchBtn: this.mapData.apply_geocoder,
                zoomBtn: true,
                geolocateBtn: this.mapData.apply_locate_user,
                refreshBtn: true,
                categoryBox: true
            },
            filter: null,
            isLoading: false,
            filteredLocationResource: [],
            filteredParcelLocations: [],
            isGeolocateLoading: false,
            chosenLocationForDirections: null,
            isClickedForDirections: false,
            defaultOrigAndDest: [],
            showRouteBtn: false,
            isOpenedListSearchBox: false,
            currentState: ''
        };
    },
    computed: {
        routeLocations() {
            const { filter, locationResource } = this;
            return filter?.route_location_ids?.length > 0
                ? locationResource.filter((location) =>
                      filter.route_location_ids.includes(location.properties.id)
                  )
                : [];
        },
        transformTranslateX0() {
            return this.mapIsLoaded ? 'transform: translateX(0);' : '';
        },
        zoomBoxStyles() {
            return {
                transform: this.mapIsLoaded ? 'translateX(0)' : '',
                bottom: !this.mapData.switch_language && this.isOnSP ? '180px' : ''
            };
        },
        isApplyCluster() {
            return this.mapData.show_cluster;
        },
        hasCustomStyle() {
            for (let key in this.mapStyles) {
                const style = this.mapStyles[key];
                if (style == this.mapData.style) {
                    return false;
                }
            }

            return true;
        },
        isOnSP() {
            return window.innerWidth <= 768;
        },
        isOutOfRange() {
            if (this.mapData.show_tooltip) {
                return false;
            }
            return this.currentZoomLevel < this.mapData.location_zoom_range[0];
        },
        isOutOfRangeCluster() {
            return this.currentZoomLevel < this.mapData.location_zoom_range[0];
        },
        locationList() {
            return this.isFiltered
                ? this.filteredLocationResource.concat(this.filteredParcelLocations)
                : this.locationGeoJson;
        },
        currentBounds() {
            return this.mySmartMap.getBounds().toArray();
        },
        sideBarNaviIndicatorState() {
            if (this.filter) {
                for (const key in this.filter) {
                    if (key === 'route_location_ids') {
                        return 'route';
                    }
                    if (this.filter[key].length != 0) {
                        return 'search';
                    }
                }
            }
            if (this.currentCategoryId) {
                return 'category';
            }
            return '';
        },
        isFiltered() {
            return this.filter &&
                (this.filter.keyword ||
                    this.filter.item ||
                    this.filter.categories.length > 0 ||
                    this.filter.facilities.length > 0 ||
                    this.filter.areas.length > 0 ||
                    (this.filter.route_location_ids && this.filter.route_location_ids.length > 0))
                ? true
                : false;
        },
        isShowMarkersWhenFiltered() {
            return this.isFiltered || this.currentCategoryId || this.isClickedLocationsFound;
        },
    },
    methods: {
        closedLocationDetail() {
            this.isShowLocationDetail = false;
            if (this.sideBarNaviIndicatorState === 'route') {
                this.openSubSidebar('routeBox');
            }
        },
        initCss() {
            setTimeout(function () {
                $('.map_loader').addClass('close');
            }, 2000);

            setTimeout(function () {
                $('.fadeIn').fadeIn('slow');
                $('.fadeIn').css('opacity', '1');
                $('.left').css('transform', 'translateX(0)');
                $('.right').css('transform', 'translateX(0)');
            }, 2500);
            var $show_control = $('.show_control');
            var control_box = $('.control_box');
            $show_control.bind('click', function () {
                control_box.slideToggle();
                $(this).toggleClass('active');
            });
            $(window).resize(function () {
                var w_width = $(window).width();
                if (w_width >= 768) {
                    control_box.removeAttr('style');
                }
            });
        },
        changeSearchIcon() {
            document.querySelector('.search_box').classList.add('search_close');
        },
        changeFullscreenButton() {
            if (!this.mapData.show_fullscreen) return;

            const isIphone = /iPhone/i.test(navigator.userAgent);
            const isIframe = window === window.parent ? false : true;
            if (!isIframe) return;

            if (!isIphone) {
                var fullscreenBtn = document.querySelector('button.mapboxgl-ctrl-fullscreen');
                fullscreenBtn.remove();
            }

            this.iframeLink = this.displayLink;
        },
        cancelSearch() {
            document.querySelector('.search_box').classList.remove('search_close');
        },
        updateCurrentCategoryId(val) {
            this.currentCategoryId = val;
            if (this.filter?.route_location_ids) {
                this.filter.route_location_ids = [];
            }
            this.$refs.listSearchBoxComponent.clearAllFilter();
        },
        clearedChosen() {
            this.chosenLocationForDirections = null;
            this.isClickedForDirections = false;
        },
        onClickMarker(payload) {
            const found = this.locationResource.find((element) => element.properties.id == payload);
            if (!found) return;

            this.hideLeftMapSections('');
            if (this.open.directionsControl) {
                this.chosenLocationForDirections = found;
                this.isClickedForDirections = true;
                return;
            }
            this.currentLocation = found;
            this.mySmartMap.flyTo({
                center: this.currentLocation.geometry.coordinates,
                speed: 2.4,
                curve: 1.2
            });
            var self = this;
            this.mySmartMap.once('idle', () => {
                self.isShowLocationDetail = true;
            });
        },
        updateTooltip(payload) {
            this.tooltip = payload;
        },
        isShowAreaMaker(area) {
            let isNoAreaFilter = this.filter ? this.filter.areas.length == 0 : true;
            return (
                (isNoAreaFilter || this.filter.areas.indexOf(area.id) != -1) &&
                this.currentZoomLevel >= area.zoom_range[0] &&
                this.currentZoomLevel < area.zoom_range[1]
            );
        },
        isShowParcelMaker(parcel) {
            return (
                this.currentZoomLevel >= parcel.zoom_range[0] &&
                this.currentZoomLevel < parcel.zoom_range[1]
            );
        },
        updateClusters() {
            if (this.isOutOfRangeCluster) {
                return (this.clusterGeoJson = []);
            }
            var clusterGeoJson = [];
            var pointsInCluster = [];
            var pointsNotInCluster = [];
            var bounds = this.mySmartMap.getBounds(),
                zoom = this.mySmartMap.getZoom();
            var clustersAndPoints = this.superclusterIndex.getClusters(
                [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()],
                Math.floor(zoom)
            );

            clustersAndPoints.forEach((feature) => {
                var isCluster = !!feature.properties.cluster ? true : false;
                if (isCluster) {
                    var clusterId = feature.id;
                    var pointCount = feature.properties.point_count;
                    var leaves = this.superclusterIndex.getLeaves(clusterId, pointCount);
                    leaves.forEach((leaf) => {
                        pointsInCluster.push(leaf.properties.id);
                    });
                    feature.properties.marker_image_url = leaves[0].properties.marker_image_url;
                    feature.expansion_zoom =
                        this.superclusterIndex.getClusterExpansionZoom(clusterId);
                    clusterGeoJson.push(feature);
                } else {
                    pointsNotInCluster.push(feature.properties.id);
                }
            });

            this.clusterGeoJson = clusterGeoJson;
            this.pointsInCluster = pointsInCluster;
            this.pointsNotInCluster = pointsNotInCluster;
        },
        handleCluster() {
            if (!this.isApplyCluster) return;
            var self = this;
            this.mySmartMap.on('moveend', function () {
                if (self.temporarilyStopCluster || self.locationGeoJson.length == 0) return;
                self.updateClusters();
            });
        },
        handleZoomChanged() {
            var self = this;
            this.mySmartMap.on('idle', function () {
                const zoom = self.mySmartMap.getZoom();

                self.isInAreaZoomRange = zoom > self.mapData.location_zoom_range[0] ? false : true;
                self.currentZoomLevel = zoom;
            });
        },
        triggerGeolocate() {
            this.isGeolocateLoading = true;
            var self = this;
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    this.triggerEventGA('get_coordinates', {
                        latitude: latitude,
                        longitude: longitude
                    });
                    self.mySmartMap.jumpTo({
                        center: [longitude, latitude],
                        zoom: 15
                    });
                },
                (error) => {
                    alert(self.trans.alert.allow_to_access_your_location);
                    setTimeout(() => {
                        self.isGeolocateLoading = false;
                    }, 10000);
                    return;
                }
            );
            this.geolocateControl.trigger();
            this.geolocateControl.on('geolocate', () => {
                self.mySmartMap.stop();
            });
            this.geolocateControl.once('trackuserlocationend', () => {
                self.isGeolocateLoading = false;
            });
        },
        filterLocations(payload) {
            this.filter = payload;
            if (this.isFiltered) {
                this.currentCategoryId = 0;
            }
        },
        resetFilter() {
            this.filter = {
                keyword: '',
                categories: [],
                item: '',
                facilities: [],
                areas: []
            };
        },
        changeMapStyle(payload) {
            this.myMapStyle = payload;
            var switchLangBtn = document.querySelector('#switch-lang-btn-' + this.currentLang);
            var self = this;

            this.mySmartMap.once('styledata', function () {
                const waiting = () => {
                    if (!self.mySmartMap.isStyleLoaded()) {
                        setTimeout(waiting, 100);
                    } else {
                        switchLangBtn.click();
                        return;
                    }
                };
                waiting();
            });
        },
        changeLocationDetail(payload) {
            var self = this;
            var zoomLevel = this.mySmartMap.getZoom() >= 17 ? this.mySmartMap.getZoom() : 17;
            this.$nextTick(() => {
                this.mySmartMap.flyTo({
                    center: payload.geometry.coordinates,
                    zoom: zoomLevel,
                    speed: 1.8
                });

                this.isShowLocationDetail = false;
                this.currentLocation = payload;

                this.mySmartMap.once('idle', () => {
                    self.isShowLocationDetail = true;
                });
            });
        },
        toggleMenu(type) {
            this.open[type] = !this.open[type];
        },
        goToMainMap() {
            const params = new URLSearchParams(window.location.search);
            if (params.get('route')) {
                return window.location.href = window.location.origin + window.location.pathname
            }
            window.location.reload();
        },
        onClickZoom(value) {
            var newZoom = this.currentZoomLevel + value;
            if (newZoom < this.mySmartMap.getMinZoom()) return;

            this.currentZoomLevel = newZoom;
        },
        onMoveend() {
            var self = this;
            this.mySmartMap.on('moveend', (e) => {
                self.updateLocationGeoJsonByBounds();
            });
        },
        isInBounds(coordinates) {
            return (
                coordinates[0] >= this.currentBounds[0][0] &&
                coordinates[0] <= this.currentBounds[1][0] &&
                coordinates[1] >= this.currentBounds[0][1] &&
                coordinates[1] <= this.currentBounds[1][1]
            );
        },
        updateLocationGeoJsonByBounds() {
            if (this.isOutOfRange) {
                this.locationGeoJson = [];
            }
            const isStop = this.isLoading || this.isOutOfRange || this.isShowLocationDetail;
            if (isStop) return;

            this.isLoading = true;
            var tempResource = this.isFiltered
                ? this.filteredLocationResource
                : this.locationResource;

            var tempGeoJson = [];
            var lengthLocation = tempResource.length;
            var countLocation = 0;
            for (let i = 0; i < lengthLocation; i++) {
                if (countLocation == 100) {
                    break;
                }
                const el = tempResource[i];
                const coordinates = el.geometry.coordinates;
                let isMatchedCurrentCategory = this.currentCategoryId
                    ? el.properties.category.id == this.currentCategoryId
                    : true;
                if (this.isInBounds(coordinates) && isMatchedCurrentCategory) {
                    tempGeoJson.push(el);
                    countLocation++;
                }
            }

            this.isLoading = false;
            this.locationGeoJson = tempGeoJson;
        },
        handleHiddenTooltip() {
            let tooltip = document.querySelector('.tootip').getAttribute('id');
            if (!tooltip) return;
            let tooltipId = tooltip.split('-')[1];
            let location = document.getElementById('spot-' + tooltipId);
            if (!location) this.updateTooltip({ title: '', top: '', left: '' });
        },
        handleNumberOfLocationsOfArea() {
            this.areaResource.forEach((area) => {
                if (area.lower_area_ids.length > 0) {
                    var total = 0;
                    for (let i = 0; i < this.areaResource.length; i++) {
                        const element = this.areaResource[i];
                        if (area.lower_area_ids.indexOf(element.id) != -1) {
                            total += element.number_of_locations;
                        }
                    }
                    area.number_of_locations = total;
                }
            });
        },
        handleTrackUserInGeofence() {
            var self = this;
            let geofenceIds = [];
            let getCurrentPosition = setInterval(() => {
                navigator.geolocation.getCurrentPosition(
                    function (pos) {
                        const crd = pos.coords;
                        var pt = turf.point([crd.longitude, crd.latitude]);
                        for (const geofence of self.geofenceResource) {
                            var poly = turf.polygon(geofence.coordinates);
                            if (turf.booleanPointInPolygon(pt, poly)) {
                                if (geofenceIds.indexOf(geofence.id) < 0) {
                                    self.triggerEventGA('track_geofence', {
                                        id: geofence.id,
                                        title: geofence.title
                                    });
                                    geofenceIds.push(geofence.id);
                                }
                            }
                        }
                    },
                    function (err) {},
                    { enableHighAccuracy: true }
                );
            }, 5000);
        },
        goToNextPoint(payload) {
            this.open.directionsControl = true;
            this.directionsControl.setOrigin(payload[0].coordinates);
            this.directionsControl.setDestination(payload[1].coordinates);
            this.defaultOrigAndDest = [payload[0].title, payload[1].title];
        },
        filterLocationsByRoute(route) {
            if (!route) {
                this.resetFilter();
                this.updateLocationGeoJsonByBounds();
                return;
            }
            this.currentCategoryId = 0;
            this.filterLocations({
                keyword: '',
                categories: [],
                item: '',
                facilities: [],
                areas: [],
                route_location_ids: route.location_ids
            });
        },
        getParcelLocations() {
            axios
                .get(
                    `/api/maps/${this.mapData.id}/parcels/locations?locale=${this.mapData.current_locale}`
                )
                .catch(function (error) {
                    console.log(error.toJSON());
                })
                .then((response) => {
                    this.parcelLocations = response.data;
                });
        },
        changeState(payload) {
            this.currentState = payload;
        },
        closeIntroduction() {
            this.open.introductionBox = false;
            const spotId = this.getSpotId();
            if (spotId) {
                this.onClickMarker(spotId);
            }
        },
        selectCategory(payload) {
            if (payload) {
                this.$refs.listSearchBoxComponent.handleClickedMainCategory(payload);
            }
        },
        closeSubSidebar(payload) {
            this.open[payload] = false;
            this.currentOpenSubSidebar = '';
        }
    },
    created() {
        if (this.isApplyCluster) {
            this.superclusterIndex = new Supercluster({
                radius: 120,
                maxZoom: 14,
                minPoints: 5,
                minZoom: 1
            });
        }

        this.getLocations();
        // Promise.all([this.getCategories(), this.getBanners(), this.getAudioGuides()]).then(
        //     () => {}
        // );
        this.handleNumberOfLocationsOfArea();
        this.getParcelLocations();
    },
    mounted() {
        var self = this;
        this.handleTrackUserInGeofence();
        this.initCss();
        this.changeFullscreenButton();
        this.loadDefaultLanguage();
        this.handleCluster();
        this.handleZoomChanged();
        // this.updateLocationGeoJsonByBounds();
        this.onMoveend();
        this.mySmartMap.once('load', () => {
            // self.updateLocationGeoJsonByBounds();
            const spotId = self.getSpotId();
            if (spotId) {
                self.onClickMarker(spotId);
            }
        });
        document
            .getElementsByClassName('mapboxgl-canvas')[0]
            .addEventListener('click', function () {
                self.isShowLocationDetail = false;
            });
    },
    watch: {
        isShowLocationDetail() {
            if (this.isShowLocationDetail) {
                this.hideAllMarkersExcept(this.currentLocation.properties.id);
                this.hideLeftMapSections('locationDetail');
                this.temporarilyStopCluster = true;
                this.setSpotId(this.currentLocation.properties.id);
            } else {
                this.currentLocation = null;
                this.temporarilyStopCluster = false;
                this.showAllMarkers();
                this.deleteSpotId();
                this.openSubSidebar(this.currentOpenSubSidebar)
            }
        },
        locationResourceIsLoaded(newVal) {
            if (newVal) {
                this.updateLocationGeoJsonByBounds();
            }
        },
        locationGeoJson(newVal, oldVal) {
            if (this.isApplyCluster) {
                this.superclusterIndex.load(newVal);
                this.updateClusters();
            }

            oldVal.forEach((el) => {
                this.removeLocationMarker(el.properties.id);
            });
            var newValLength = newVal.length;
            var countItem = 0;
            for (let i = 0; i < newValLength; i++) {
                if (countItem == 100) break;
                let el = newVal[i];
                const locationId = el.properties.id;
                const isInCluster = this.pointsInCluster.includes(locationId);
                const notExistsOnMap = !this.locationMarkers.has(locationId);
                if (isInCluster) {
                    this.removeLocationMarker(locationId);
                } else if (notExistsOnMap && this.isInBounds(el.geometry.coordinates)) {
                    this.addLocationMarker(el);
                    countItem++;
                }
            }
            this.handleHiddenTooltip();
        },
        clusterGeoJson(newVal, oldVal) {
            oldVal.forEach((old) => {
                let isExists = newVal.some((el) => el.id == old.id);
                if (!isExists) {
                    this.removeClusterMarker(old.id);
                }
            });

            newVal.forEach((item) => {
                let isExists = oldVal.some((el) => el.id == item.id);
                if (!isExists) {
                    this.addClusterMarker(item);
                }
            });
        },
        currentCategoryId(newVal) {
            if (this.isFiltered) return;
            if (!newVal) {
                this.locationGeoJson = this.locationResource;
                return;
            }
            this.locationGeoJson = this.locationResource.filter(
                (item) => item.properties.category.id == newVal
            );
        },
        filter: {
            deep: true,
            handler: function (newVal) {
                if (this.currentCategoryId && !this.isFiltered) {
                    return;
                }
                if (this.isOutOfRange) {
                    this.mySmartMap.flyTo({
                        zoom: this.mapData.location_zoom_range[0],
                        speed: 1.8
                    });
                }
                var result = [];
                const locationLength = this.locationResource.length;
                for (let i = 0; i < locationLength; i++) {
                    const currentLocation = this.locationResource[i];
                    const properties = currentLocation.properties;
                    if (newVal.route_location_ids) {
                        if (newVal.route_location_ids.includes(properties.id)) {
                            result.push(currentLocation);
                        }
                        continue;
                    }
                    if (
                        !newVal.keyword &&
                        newVal.categories.length == 0 &&
                        !newVal.item &&
                        newVal.areas.length == 0 &&
                        newVal.facilities.length == 0
                    ) {
                        result.push(currentLocation);
                        continue;
                    }

                    if (newVal.keyword) {
                        var isMatchedKeyword = this.searchByKeyword(properties, newVal.keyword);
                        if (!isMatchedKeyword) continue;
                    }
                    if (
                        newVal.categories.length > 0 &&
                        !newVal.categories.includes(properties.category.id)
                    ) {
                        continue;
                    }
                    if (newVal.item) {
                        const itemFound = properties.items.find((item) => item.id == newVal.item);
                        if (!itemFound) continue;
                    }
                    if (newVal.facilities.length > 0) {
                        var isMatchedFacility = false;
                        const facilityLength = properties.facilities.length;
                        for (let i = 0; i < facilityLength; i++) {
                            const facility = properties.facilities[i];
                            if (newVal.facilities.includes(facility.id)) {
                                isMatchedFacility = true;
                                break;
                            }
                        }
                        if (!isMatchedFacility) continue;
                    }
                    if (newVal.areas.length > 0) {
                        var isMatchedArea = false;
                        if (properties.upper_areas) {
                            properties.upper_areas.forEach((area) => {
                                if (newVal.areas.includes(area.id) && area.type == 1) {
                                    isMatchedArea = true;
                                }
                            });
                        }
                        if (!isMatchedArea) continue;
                    }
                    result.push(currentLocation);
                }
                this.filteredLocationResource = result;
                this.locationGeoJson = this.filteredLocationResource;
            }
        },
        'filter.keyword': function (newVal) {
            if (this.parcelLocations.length == 0 || !newVal) {
                return;
            }

            var result = [];
            this.parcelLocations.forEach((location) => {
                var props = location.properties;
                var isMatched = this.searchByKeyword(props, newVal);
                if (isMatched) {
                    result.push(location);
                }
            });

            this.filteredParcelLocations = result;
        }
    }
};
</script>

<style>
.fit-icon-marker {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    height: 57px;
    width: 57px;
    border-radius: 50%;
}
button.mapboxgl-ctrl-geolocate,
button.mapboxgl-ctrl-fullscreen {
    display: none;
}
.bubble {
    top: -2.1rem;
}
@media print, screen and (max-width: 768px) {
    .bubble {
        top: -2.1rem;
    }
}

@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.bubble {
    top: -2.1rem;
}

.tooltip-ttl {
    position: absolute;
    width: max-content;
    left: 12px;
    top: -4px;
    z-index: -1;
    text-shadow: rgb(255, 255, 255) 1px 0px 0px, rgb(255, 255, 255) 0.540302px 0.841471px 0px, rgb(255, 255, 255) -0.416147px 0.909297px 0px, rgb(255, 255, 255) -0.989992px 0.14112px 0px, rgb(255, 255, 255) -0.653644px -0.756802px 0px, rgb(255, 255, 255) 0.283662px -0.958924px 0px, rgb(255, 255, 255) 0.96017px -0.279415px 0px;
}
.custom-tooltip-ttl {
    position: absolute;
    width: max-content;
    left: 18px;
    top: -4px;
    z-index: -1;
    text-shadow: rgb(255, 255, 255) 1px 0px 0px, rgb(255, 255, 255) 0.540302px 0.841471px 0px, rgb(255, 255, 255) -0.416147px 0.909297px 0px, rgb(255, 255, 255) -0.989992px 0.14112px 0px, rgb(255, 255, 255) -0.653644px -0.756802px 0px, rgb(255, 255, 255) 0.283662px -0.958924px 0px, rgb(255, 255, 255) 0.96017px -0.279415px 0px;
}
.tooltip-box {
    left: -4px;
}
.tooltip-marker {
    -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 1);
    -moz-box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 1);
}

.pin::before {
    -webkit-mask-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMyIgaGVpZ2h0PSIzIiB2aWV3Qm94PSIwIDAgMyAzIj4gPGRlZnM+IDxjbGlwUGF0aCBpZD0iY2xpcC1NYXJrZXIiPiA8cmVjdCB3aWR0aD0iMyIgaGVpZ2h0PSIzIi8+IDwvY2xpcFBhdGg+IDwvZGVmcz4gPGcgaWQ9Ik1hcmtlciIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAtTWFya2VyKSI+IDxwYXRoIGlkPSLjg5HjgrlfMzIyNiIgZGF0YS1uYW1lPSLjg5HjgrkgMzIyNiIgZD0iTTI1LjU1NSwxMC4wMjZhNC4yMTQsNC4yMTQsMCwwLDAtMS45MjIsNy42NDlBNS4yOTIsNS4yOTIsMCwwLDEsMjUuOSwyMS4yMTZsLjAxOC4xMjFhLjE2Ny4xNjcsMCwwLDAsLjMzMSwwbC4wNC0uMjY1YTUuMTA3LDUuMTA3LDAsMCwxLDIuMTY2LTMuNDA2LDQuMjE1LDQuMjE1LDAsMCwwLTIuOS03LjY0Wm0uNDgxLDUuODM0YTEuNjQ3LDEuNjQ3LDAsMSwxLDEuNjQ3LTEuNjQ3QTEuNjQ3LDEuNjQ3LDAsMCwxLDI2LjAzNiwxNS44NjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy41MjUgMjEuNDgpIHJvdGF0ZSgxODApIi8+IDwvZz48L3N2Zz4=');
    mask-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMyIgaGVpZ2h0PSIzIiB2aWV3Qm94PSIwIDAgMyAzIj4gPGRlZnM+IDxjbGlwUGF0aCBpZD0iY2xpcC1NYXJrZXIiPiA8cmVjdCB3aWR0aD0iMyIgaGVpZ2h0PSIzIi8+IDwvY2xpcFBhdGg+IDwvZGVmcz4gPGcgaWQ9Ik1hcmtlciIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAtTWFya2VyKSI+IDxwYXRoIGlkPSLjg5HjgrlfMzIyNiIgZGF0YS1uYW1lPSLjg5HjgrkgMzIyNiIgZD0iTTI1LjU1NSwxMC4wMjZhNC4yMTQsNC4yMTQsMCwwLDAtMS45MjIsNy42NDlBNS4yOTIsNS4yOTIsMCwwLDEsMjUuOSwyMS4yMTZsLjAxOC4xMjFhLjE2Ny4xNjcsMCwwLDAsLjMzMSwwbC4wNC0uMjY1YTUuMTA3LDUuMTA3LDAsMCwxLDIuMTY2LTMuNDA2LDQuMjE1LDQuMjE1LDAsMCwwLTIuOS03LjY0Wm0uNDgxLDUuODM0YTEuNjQ3LDEuNjQ3LDAsMSwxLDEuNjQ3LTEuNjQ3QTEuNjQ3LDEuNjQ3LDAsMCwxLDI2LjAzNiwxNS44NjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy41MjUgMjEuNDgpIHJvdGF0ZSgxODApIi8+IDwvZz48L3N2Zz4=');
    background-color: inherit;
    content: '';
    height: 4.2rem;
    -webkit-mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzIiBoZWlnaHQ9IjMiPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZD0iTTAgMGgzdjNIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyBjbGlwLXBhdGg9InVybCgjYSkiPjxwYXRoIGRhdGEtbmFtZT0i44OR44K5IDMyMjYiIGQ9Ik0xLjk3IDExLjQ1NGE0LjIxNCA0LjIxNCAwIDAgMCAxLjkyMi03LjY0OUE1LjI5MiA1LjI5MiAwIDAgMSAxLjYyNS4yNjRMMS42MDcuMTQzYS4xNjcuMTY3IDAgMCAwLS4zMzEgMGwtLjA0LjI2NUE1LjEwNyA1LjEwNyAwIDAgMS0uOTMgMy44MTRhNC4yMTUgNC4yMTUgMCAwIDAgMi45IDcuNjRaTTEuNDg5IDUuNjJBMS42NDcgMS42NDcgMCAxIDEtLjE1OCA3LjI2N2ExLjY0NyAxLjY0NyAwIDAgMSAxLjY0Ny0xLjY0OFoiLz48L2c+PC9zdmc+);
    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzIiBoZWlnaHQ9IjMiPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZD0iTTAgMGgzdjNIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyBjbGlwLXBhdGg9InVybCgjYSkiPjxwYXRoIGRhdGEtbmFtZT0i44OR44K5IDMyMjYiIGQ9Ik0xLjk3IDExLjQ1NGE0LjIxNCA0LjIxNCAwIDAgMCAxLjkyMi03LjY0OUE1LjI5MiA1LjI5MiAwIDAgMSAxLjYyNS4yNjRMMS42MDcuMTQzYS4xNjcuMTY3IDAgMCAwLS4zMzEgMGwtLjA0LjI2NUE1LjEwNyA1LjEwNyAwIDAgMS0uOTMgMy44MTRhNC4yMTUgNC4yMTUgMCAwIDAgMi45IDcuNjRaTTEuNDg5IDUuNjJBMS42NDcgMS42NDcgMCAxIDEtLjE1OCA3LjI2N2ExLjY0NyAxLjY0NyAwIDAgMSAxLjY0Ny0xLjY0OFoiLz48L2c+PC9zdmc+);
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: contain;
    mask-size: contain;
    position: absolute;
    transform: rotate(180deg);
    width: 1rem;
    top: -10px;
    left: 15px;
}
</style>
